import React from "react";
import { useRef, useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Contact = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [fileName, setFileName] = useState("No file chosen");

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    emailjs
      .sendForm(
        "service_x0qp7zc",
        "template_2s4894j",
        form.current,
        "tmTWW-hXcDhbB5j6e",
      )
      .then(
        (result) => {
          console.log(result.text);
          setSubmitStatus("success");
          setIsSubmitting(false);
          setTimeout(() => setSubmitStatus(null), 3000);
          e.target.reset();
          setFileName("No file chosen");
        },
        (error) => {
          console.log(error.text);
          setSubmitStatus("error");
          setIsSubmitting(false);
          setTimeout(() => setSubmitStatus(null), 3000);
        },
      );
  };

  const handleReset = (e) => {
    e.preventDefault();
    form.current.reset();
    setFileName("No file chosen");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file ? file.name : "No file chosen");
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://unpkg.com/aos@2.3.1/dist/aos.js";
    script.async = true;
    script.onload = () => {
      if (window.AOS) {
        window.AOS.init({
          duration: 800,
          once: true,
          offset: 100,
        });
      }
    };
    document.body.appendChild(script);

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://unpkg.com/aos@2.3.1/dist/aos.css";
    document.head.appendChild(link);

    return () => {
      document.body.removeChild(script);
      document.head.removeChild(link);
    };
  }, []);

  return (
    <>
      <div className="container-fluid p-0 banner-section">
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-5 text-white text-center">
            <h1 className="pt-3 mt-5 banner-title">Contact Us</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Contact Us
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="container my-5">
        <div className="row g-4">
          <div className="col-md-7" data-aos="fade-right">
            <div className="map-card">
              <iframe
                className="google-map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1891.6185221993464!2d73.93378561744383!3d18.518187200000007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c22241555591%3A0x55b4e980eb492d65!2sAmanora%20Chambers!5e0!3m2!1sen!2sin!4v1745212764588!5m2!1sen!2sin"
                width="100%"
                height="350"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Office Location"
              ></iframe>
              <div className="map-footer">
                <i className="fa-regular fa-building"></i> Amanora Chambers,
                Magarpatta, Pune
              </div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="contact-cards">
              <div className="contact-card card-address animate-card">
                <div className="card-icon">
                  <i className="fa-solid fa-map-marker-alt"></i>
                </div>
                <div className="card-details">
                  <h4>Visit Our Office</h4>
                  <p>
                    <a
                      style={{ color: "#475569" }}
                      href="https://maps.app.goo.gl/2qGi1S3R9yyyG6GN6"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-text text-decoration-none"
                    >
                      Office number 419 Amanora Chambers Magarpatta, Hadapsar,
                      Pune 411028, Maharashtra.
                    </a>
                  </p>
                  <span className="card-time">
                    <i className="fa-regular fa-clock"></i>
                    {" "}Mon-Fri: 10:00 AM - 7:00 PM
                  </span>
                </div>
                <div className="card-hover-effect"></div>
              </div>
              <div className="contact-card card-email animate-card">
                <div className="card-icon">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div className="card-details">
                  <h4>Email Us</h4>
                  <p>
                    <a
                      style={{ color: "#475569" }}
                      href="mailto:info@digiopenservices.com"
                    >
                      info@digiopenservices.com
                    </a>
                  </p>
                </div>
                <div className="card-hover-effect"></div>
              </div>
              <div className="contact-card card-phone animate-card">
                <div className="card-icon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div className="card-details">
                  <h4>Call / WhatsApp</h4>
                  <p>
                    <a style={{ color: "#475569" }} href="tel: +91 9175476370">
                      +91 9175476370{" "}
                    </a>
                  </p>
                </div>
                <div className="card-hover-effect"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .banner-section {
          position: relative;
          min-height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .banner-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="rgba(255,255,255,0.1)" fill-opacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,165.3C1248,149,1344,107,1392,85.3L1440,64L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path></svg>')
            repeat-x bottom;
          background-size: cover;
          opacity: 0.3;
          animation: slideBackground 20s linear infinite;
        }

        @keyframes slideBackground {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }

        .banner-title {
          font-size: 3rem;
          font-weight: 700;
          animation: fadeInDown 0.8s ease-out;
          position: relative;
          z-index: 1;
        }

        .breadcrumb-item a,
        .breadcrumb-item {
          font-size: 1.1rem;
          animation: fadeInUp 0.8s ease-out;
          position: relative;
          z-index: 1;
        }

        .form-wrapper {
          position: relative;
          background: #ffffff;
          border-radius: 32px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .form-wrapper:hover {
          box-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.2);
        }

        .form-decoration {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          pointer-events: none;
          overflow: hidden;
        }

        .decoration-circle {
          position: absolute;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.05), rgba(118, 75, 162, 0.05));
        }

        .circle-1 {
          width: 300px;
          height: 300px;
          top: -150px;
          right: -100px;
        }

        .circle-2 {
          width: 200px;
          height: 200px;
          bottom: -80px;
          left: -80px;
        }

        .circle-3 {
          width: 150px;
          height: 150px;
          top: 40%;
          right: 10%;
        }

        .attractive-form {
          position: relative;
          padding: 40px;
          z-index: 1;
        }

        .form-header-section {
          text-align: center;
          margin-bottom: 40px;
        }

        .form-badge {
          display: inline-block;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 6px 16px;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 16px;
        }

        .form-title {
          font-size: 2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 12px;
        }

        .form-subtitle {
          color: #64748b;
          font-size: 0.95rem;
        }

        .form-row {
          margin-bottom: 14px;
        }

        .form-row.three-columns {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        .form-row.two-columns {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }

        .form-group {
          position: relative;
        }

        .form-group.full-width {
          grid-column: span 1;
        }

        .form-label {
          display: block;
          font-weight: 600;
          color: #334155;
          margin-bottom: 8px;
          font-size: 0.9rem;
        }

        .form-label i {
          color: #667eea;
          margin-right: 6px;
        }

        .required {
          color: #ef4444;
        }

        .form-input,
        .form-textarea {
          width: 100%;
          padding: 14px 18px;
          border: 2px solid #e2e8f0;
          border-radius: 16px;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          background: #f8fafc;
          font-family: inherit;
        }

        .form-textarea {
          resize: vertical;
          min-height: 70px;
        }

        .form-input:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #667eea;
          background: #ffffff;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        }

        .input-focus-border {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #667eea, #764ba2);
          transition: width 0.3s ease;
        }

        .form-input:focus ~ .input-focus-border,
        .form-textarea:focus ~ .input-focus-border {
          width: 100%;
        }

        .file-upload-wrapper {
          position: relative;
        }

        .file-input {
          position: absolute;
          opacity: 0;
          width: 0;
          height: 0;
        }

        .file-label {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 20px;
          background: #f8fafc;
          border: 2px dashed #cbd5e1;
          border-radius: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
          justify-content: center;
          font-weight: 500;
        }

        .file-label:hover {
          border-color: #667eea;
          background: #f1f5f9;
          color: #667eea;
        }

        .file-name {
          display: block;
          font-size: 0.8rem;
          color: #64748b;
          margin-top: 10px;
          text-align: center;
        }

        .toast-message {
          padding: 14px 20px;
          border-radius: 16px;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          gap: 10px;
          animation: slideIn 0.3s ease;
        }

        .toast-message.success {
          background: #ecfdf5;
          color: #059669;
          border-left: 4px solid #10b981;
        }

        .toast-message.error {
          background: #fef2f2;
          color: #dc2626;
          border-left: 4px solid #ef4444;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .form-actions {
          display: flex;
          gap: 16px;
          justify-content: flex-end;
          margin-top: 32px;
        }

        .btn-reset {
          padding: 12px 32px;
          background: transparent;
          border: 2px solid #e2e8f0;
          border-radius: 40px;
          font-weight: 600;
          color: #475569;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .btn-reset:hover {
          border-color: #667eea;
          color: #667eea;
          background: #f8fafc;
          transform: translateY(-2px);
        }

        .btn-submit {
          padding: 12px 36px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 40px;
          font-weight: 600;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }

        .btn-submit:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px -5px rgba(102, 126, 234, 0.4);
        }

        .btn-submit:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .form-footer {
          display: flex;
          justify-content: space-between;
          margin-top: 28px;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
          font-size: 0.8rem;
          color: #64748b;
        }

        .trust-badge i,
        .response-time i {
          margin-right: 6px;
          color: #667eea;
        }

        .map-card {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
          background: white;
        }

        .map-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 30px 50px rgba(0, 0, 0, 0.15);
        }

        .google-map {
          transition: transform 0.5s ease;
          width: 100%;
          height: 350px;
          border: none;
        }

        .map-card:hover .google-map {
          transform: scale(1.02);
        }

        .map-footer {
          position: absolute;
          bottom: 20px;
          right: 20px;
          background: rgba(0, 0, 0, 0.75);
          backdrop-filter: blur(8px);
          padding: 6px 15px;
          border-radius: 50px;
          font-size: 0.75rem;
          color: white;
          z-index: 2;
          pointer-events: none;
        }

        .contact-cards {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .contact-card {
          position: relative;
          background: white;
          border-radius: 20px;
          padding: 20px;
          display: flex;
          gap: 18px;
          transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
          cursor: pointer;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(102, 126, 234, 0.1);
        }

        .animate-card {
          opacity: 0;
          transform: translateX(30px);
          animation: slideInRight 0.6s ease-out forwards;
        }

        .contact-card:nth-child(1) { animation-delay: 0.1s; }
        .contact-card:nth-child(2) { animation-delay: 0.2s; }
        .contact-card:nth-child(3) { animation-delay: 0.3s; }

        .contact-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 30px rgba(102, 126, 234, 0.15);
          border-color: rgba(102, 126, 234, 0.3);
        }

        .card-icon {
          width: 55px;
          height: 55px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: white;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .contact-card:hover .card-icon {
          transform: scale(1.1) rotate(5deg);
        }

        .card-details {
          flex: 1;
        }

        .card-details h4 {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 8px;
        }

        .card-details p {
          font-size: 0.9rem;
          color: #475569;
          margin-bottom: 5px;
          line-height: 1.4;
        }

        .card-time {
          font-size: 0.75rem;
          color: #667eea;
          display: inline-flex;
          align-items: center;
          gap: 5px;
        }

        .card-hover-effect {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.08), transparent);
          transition: left 0.6s ease;
          pointer-events: none;
        }

        .contact-card:hover .card-hover-effect {
          left: 100%;
        }

        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(30px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @media (max-width: 992px) {
          .form-row.three-columns {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }
        }

        @media (max-width: 768px) {
          .banner-title { font-size: 2rem; }
          .attractive-form { padding: 24px; }
          .form-title { font-size: 1.5rem; }
          
          .form-row.three-columns {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          
          .form-row.two-columns {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          
          .form-group.full-width {
            grid-column: span 1;
          }
          
          .form-actions { 
            flex-direction: column;
            gap: 12px;
          }
          
          .btn-reset, .btn-submit { 
            width: 100%; 
            justify-content: center;
            padding: 12px 20px;
          }
          
          .form-footer { 
            flex-direction: column; 
            gap: 8px; 
            text-align: center; 
          }
          
          .contact-card { padding: 15px; }
          .card-icon { width: 45px; height: 45px; font-size: 1.2rem; }
          .google-map { height: 280px; }
        }

        @media (max-width: 480px) {
          .form-input, .form-textarea {
            padding: 12px 14px;
          }
          
          .form-badge {
            font-size: 0.75rem;
          }
          
          .form-title {
            font-size: 1.3rem;
          }
        }
      `}</style>
    </>
  );
};

export default Contact;